import {Box, Divider, Flex, Image, Text, useDisclosure, ScaleFade, Button} from "@chakra-ui/react";
import logo from "../../assets/images/logo.svg";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const Menu = ({ variant = "default" }) => {
    const navigate = useNavigate();
    const {logout} = useAuth();

    const handleNavigate = (route) => {
        navigate(route);
    }

    const handleLogout = () => {
        logout();
    }

    return (
        <Flex bg={'white'} w={'100vw'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}
              position="sticky" top="0" zIndex="999">
            <Flex bg={'white'} w={'100vw'} py='12px' px={4} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
                <Flex w={{base: '100%', sm: '7xl'}} justifyContent={'space-between'} alignItems={'center'}>
                    <Box w={"full"} display={'flex'} justifyContent="space-between" alignItems="center" columnGap={4}>

                        <Image src={logo} h={{base: '40px', sm: 12}} cursor={'pointer'} onClick={() => handleNavigate("/")}/>

                        {variant === "default" ? (
                            <Button
                                bg="white"
                                _hover={{ bgColor: 'white' }}
                                w="215px"
                                h="48px"
                                color="#979797"
                                borderRadius="0"
                                fontFamily="Poppins"
                                fontWeight="600"
                                fontSize="14px"
                                border="0"
                                onClick={handleLogout}
                            >
                                Wyloguj się
                            </Button>
                        ) : (
                            <Button
                                bg="white"
                                _hover={{ bgColor: 'white' }}
                                w="215px"
                                h="48px"
                                color="#0A4725"
                                borderRadius="0"
                                gap="10px"
                                fontFamily="Poppins"
                                fontWeight="600"
                                fontSize="14px"
                                border="2px"
                                borderColor="#0A4725"
                                as="a"
                                href="#events"
                            >
                                Sprawdź wydarzenia
                                <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 0H4.08481L8.5 5L4.08481 10H0.5L4.93544 5L0.5 0Z" fill="#0A4725"/>
                                </svg>
                            </Button>
                        )}

                    </Box>
                </Flex>
            </Flex>
            <Divider borderColor={'#A2C2B0'} display={{base: 'none', sm: 'block'}}/>
        </Flex>
    )
}

export default Menu;
